<template>
  <b-card>
    <b-form-group label="Data do Evento:">
      <DateInput
        input-class="form-control"
        v-model="cronograma.data_evento"
        format="dd/MM/yyyy"
        :state="validateState('data_evento')"
      />
      <b-form-invalid-feedback :state="validateState('data_evento')"
        >Data do evento é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>
    <b-form-group label="Descrição:">
      <b-form-input
        v-model="cronograma.descricao"
        placeholder="Descrição"
        :state="validateState('descricao')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Descrição é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>
  </b-card>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, decimal } from "vuelidate/lib/validators";
import { mapGetters, mapState } from "vuex";
import DateInput from "@/components/Form/DateInput.vue";
import _ from "lodash";

export default {
  mixins: [validationMixin],
  components: { DateInput },
  props: {
    edit: {},
  },
  data: () => ({
    cronograma: {},
  }),
  validations: {
    cronograma: {
      data_evento: {
        required,
      },
      descricao: {
        required,
      },
    },
  },
  computed: {
    ...mapState("oportunidades", ["oportunidade"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.cronograma[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.cronograma.$touch();
      return !this.$v.cronograma.$anyError;
    },
    setCronograma(cronograma) {
      this.cronograma = cronograma;
    },
    save() {
      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });

        return null;
      }
      return this.cronograma;
    },
  },
  watch: {
    edit: function (value, new_value) {
      if (value) {
        this.setCronograma(value);
      }
    },
  },
  created() {
    this.setCronograma({
      oportunidade_id: null,
      data_evento: null,
      descricao: null,
    });
  },
};
</script>

<style>
</style>
